module.exports = __webpack_public_path__ + "static/img/200291.b1e507a4.png";